export default __webpack_public_path__ + "static/media/spiritofyggdrasil.644d5454.png";